import { Grid, Paper, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { joinCustomerNames } from "../../../../../services/customersService";

export function EditSharesList({ shares, customers, readOnly, onChange }) {
    const { t } = useTranslation();

    const updateSharePercentage = (index, value) => {
        if (readOnly) {
            return;
        }
        const v = Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0;
        const updated = shares.map((s, i) => (i === index ? { ...s, percentage: v } : s));
        onChange(updated);
    };

    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Grid container direction="column" rowSpacing={1.5}>
                {shares.map((s, idx) => {
                    const groupCustomers = s.customerIds
                        .map((id) => customers.find((c) => c.id === id))
                        .filter(Boolean);
                    const names = joinCustomerNames(groupCustomers);
                    return (
                        <Grid item key={`${names}-${idx}`}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={8}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label={t("agreements.customersData.names") || "Name(s)"}
                                        value={names}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        label={
                                            t("agreements.customersData.percentage") ||
                                            "Percentage share"
                                        }
                                        value={s.percentage}
                                        inputProps={{ min: 0, max: 100, step: 1 }}
                                        onChange={(e) =>
                                            updateSharePercentage(
                                                idx,
                                                Number.parseFloat(e.target.value),
                                            )
                                        }
                                        disabled={readOnly}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
                {shares.length === 0 && (
                    <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                        {t("agreements.customersData.noShares") ||
                            "No shares. Select clients first."}
                    </Typography>
                )}
            </Grid>
        </Paper>
    );
}
